import type { RouteRecordRaw } from 'vue-router';

import DefaultLayout from '@/layouts/DefaultLayout.vue';

import { useOrganizationsStore } from '@/stores/v2/OrganizationStore.ts';

export const vendorRoutes: RouteRecordRaw[] = [
  {
    path: '/vendors',
    name: 'vendors',
    meta: { layout: DefaultLayout },
    component: () => import('@/pages/Vendors/VendorsPage.vue'),
    beforeEnter: (to, from, next) => {
      const organizationsStore = useOrganizationsStore();

      if (organizationsStore.vendorsEnabled && organizationsStore.governanceEnabled) {
        next();
      } else {
        next({ name: 'home' });
      }
    },
    children: [
      {
        path: '',
        name: 'vendors-overview',
        component: () => import('@/pages/Vendors/VendorsOverview.vue'),
      },
      {
        path: 'vendor-detail/:vendorId',
        name: 'vendor-detail',
        component: () => import('@/pages/Vendors/VendorDetailPage.vue'),
      },
    ],
  },
];
